import { ViewStyle } from 'react-native';
import { DeviceMode } from 'src/state/context/AppSettings';

export const DEFAULT_CARD_HEIGHT_DESKTOP = 278;
export const DEFAULT_CARD_WIDTH_DESKTOP = 276;
export const DEFAULT_CARD_HEIGHT_TABLET = 292;
export const DEFAULT_CARD_WIDTH_TABLET = 276;

type GridCardStylesVariantsConfig = Record<DeviceMode, { width: number; height: number } & ViewStyle>

enum GridCardStylesVariantsEnum {
  FOLDER_ICON = 'FOLDER_ICON',
  THUMBNAIL = 'THUMBNAIL',
}
type GridCardStylesVariant = keyof typeof GridCardStylesVariantsEnum;

export const GRID_CARD_STYLES_VARIANTS_CONFIGS = {
  FOLDER_ICON: {
    desktop: {
      width: 40,
      height: 40,
    },
    tablet: {
      width: 48,
      height: 48,
    },
  },
  THUMBNAIL: {
    desktop: {
      width: 252,
      height: 140,
    },
    tablet: {
      width: 252,
      height: 140,
    },
  },
} satisfies Record<GridCardStylesVariant, GridCardStylesVariantsConfig>;

export default {
  DEFAULT_CARD_HEIGHT_DESKTOP,
  DEFAULT_CARD_WIDTH_DESKTOP,
  DEFAULT_CARD_HEIGHT_TABLET,
  DEFAULT_CARD_WIDTH_TABLET,
  GRID_CARD_STYLES_VARIANTS_CONFIGS,
}
